module.exports = __webpack_public_path__ + "img/diagram-3.9660e88e.svg";